import { createApp } from 'vue'
import Main from './Main.vue'
import router from './router'
import './assets/main.css'
import naive from 'naive-ui'

const app = createApp(Main)
app.use(naive)

app.use(router)
app.mount('#app')
